import React, { lazy } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import withSuspense from '../../../helpers/withSuspense.jsx';
import ButtonSkeleton from '../../../skeleton_loaders/common/ButtonSkeleton.jsx';
import { useTaskOptions } from '../hooks/useTaskOptions.js';
const ColumnSelector2 = withSuspense(lazy(() => import('../../common/ColumnSelector2.jsx'), <ButtonSkeleton />));
import {
  task_update_visible_columns_path
} from '~/routes';

function TaskColumnSelector({ projectId, btnStyle }) {
  const queryClient = useQueryClient();
  const {sorted_columns, visible_columns} = useTaskOptions({projectId});

  const removeQueryCache = () => {
    queryClient.removeQueries({
      queryKey: ['task_column_options', projectId],
      exact: true,
    })
  }

  return (<>
    {sorted_columns
      ?
       <ColumnSelector2
          label={I18n.t('columns')}
          columns={sorted_columns}
          selected={visible_columns}
          btnClassName='btn btn-md btn-default'
          updateColumnsUrl={task_update_visible_columns_path({project_id: projectId})}
          reloadPage={true}
          btnStyle={btnStyle}
          onCallback={removeQueryCache}
        />
      : <ButtonSkeleton />
    }
    </>
  )
}

export default TaskColumnSelector;